var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99996 6.24519L8.75469 9.99993L9.99992 8.7547L6.24518 4.99996L9.99992 1.24522L8.75469 0L4.99996 3.75474L1.24522 0L0 1.24522L3.75473 4.99996L0 8.7547L1.24522 9.99993L4.99996 6.24519ZM9.1697 1.24515L9.16977 1.24522L5.41503 4.99996L5.41496 4.99989L9.1697 1.24515ZM1.24515 9.16971L1.24522 9.16978L4.99996 5.41504L4.99989 5.41497L1.24515 9.16971ZM8.75462 9.16971L8.75469 9.16978L9.16977 8.7547L9.1697 8.75463L8.75462 9.16971Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBox);
export default __webpack_public_path__ + "static/media/closeBox.2acfd8a95bdf1922c543076ec52bbb79.svg";
export { ForwardRef as ReactComponent };